module.exports = __webpack_public_path__ + "static/media/pinkSkirt.0c3eea58.jpg";